const TRUTHY = new Set(['true', '1', 'yes']);

export function isOfflineEnabled(value?: unknown): boolean {
    if (value === true || value === 1) {
        return true;
    }

    return TRUTHY.has(String(value ?? '').toLowerCase().trim());
}

export function isOfflinePath(path: string): boolean {
    const normalized = path.replace(/\/+$/, '') || '/';
    return normalized === '/offline' || normalized.endsWith('/offline');
}

export function offlineEnvValue(): string | undefined {
    return process.env.OFFLINE ?? process.env.NUXT_PUBLIC_OFFLINE;
}
